// Init HTMX

(function (window) {
  'use strict';

  if (window.htmx) {
    window.htmx.config.requestClass = 'lazyloading';
  }
})(this);
